import React from 'react'
import '../../../App.scss';
import Grid from "@material-ui/core/Grid";
import Button from "../../pageComponents/Settings/Free/Button";
import IconButton from "../Settings/IconButton";
import goldCoin from "../../../assets/images/ic_coin.png";
import silverCoin from "../../../assets/images/ic_silver_coin.png";
import SquareAvatar from "../Settings/SquareAvatar";
import axios from "axios";
import {avatarBuy, avatarList} from "../../../Utility/Url";
import PicoLoader from "./PicoLoader";
import {connect} from "react-redux";
import Shadow from './Shadow'
import {data as reduxData} from "../../../Store/Actions/DataAction";
class AvatarBuyDialog extends React.Component{
    constructor() {
        super()
        this.state={
            picoSmallLoader:false,
            err:null,
        }
    }
    componentDidMount() {
    }
    avatarBuy=async (id)=>{
        const {data:{dialog}}=this.props.data
        const {price,stars,type}=dialog.data
        const data=this.props.UserData.userData

        if (stars>data.stats.stars)
            this.setState({
                err:'متاسفانه هنوز به سطح مورد نظر نرسیده اید'
            })
         else if (type==='silver' && price > data.properties.silver){
            this.setState({
                err:'سکه نقره کافی نیست'
            })
        }
        else if (type==='golden' && price > data.properties.golden){
            this.setState({
                err:'سکه طلا کافی نیست'
            })
        }
        else {
            this.setState({
                picoSmallLoader:true
            })
            await axios.post(avatarBuy,{
                id:id
            })
                .then(res => {
                    const {data}=res
                    this.setState({
                        picoSmallLoader:false
                    })
                    if (data.success)
                        window.location.reload()
                }).catch(error=>{
                        console.log(error.toString())
                    }
                )
        }
    }
    render() {
        const {button,data:{dialog,success}}=this.props.data
        const {bought,id,price,stars,type,url}=dialog.data
        const okText=()=>{
            if (bought==='1')
                return 'انتخاب'
            // else if (price==='0')
            //     return 'ثبت'
            else {
                return 'خرید'
            }
        }
        const okButton={
            text:okText(),
            backgroundColor:dialog.ok?dialog.ok.backgroundColor:'grey',
            bottomFontSize:'15px',
            buttonTextColor:'#ffffff',
            borderColor:'transparent',
            action:dialog.ok?dialog.ok.action:'',
            icon:bought==='0'?(type==='silver'?silverCoin:goldCoin):null,
            iconQuantity:bought==='0'?(price):null,
            bought:bought,

        }
        const cancelButton={
            text:dialog.cancel?dialog.cancel.text:'',
            backgroundColor:'grey',
            bottomFontSize:'15px',
            buttonTextColor:'#ffffff',
            borderColor:'transparent',
            action:'close'
        }
        const{picoSmallLoader,err}=this.state
        const avatarData={
            url:url,
            showStars:true,
            stars:stars
        }
        return (
            <Grid sm={12} xs={12} alignItems={"center"} container justify={"flex-end"}
                  className='dialog' style={{backgroundColor:dialog.style.background,border:'none',height:'100%',width:'100%'}}>
                <Grid sm={12} xs={12} alignItems={"center"} direction={"row"} style={{height:'50px',position:'relative',cursor:'none'}} container justify={"center"}>
                    {/*<Button data={button}/>*/}
                    <Shadow/>
                </Grid>
                <Grid sm={12} xs={12} style={{backgroundColor:dialog.style.contentColor,border:'none'}} direction={"reverse"} className='dialog-text-container' alignItems={"center"}  container justify={"center"}>
                    <Grid sm={6} xs={6} alignItems={"center"} direction={"row-reverse"}  justify={"center"} container style={{padding:'10px 0'}}>
                        <Grid container alignItems={"center"} justify={"center"}>
                            <p style={{color:dialog.style.contentTextColor}}>
                                {dialog.message}
                            </p>
                        </Grid>
                        {
                            (price==='0' && bought==='0') &&
                            <Grid sm={6} xs={6} style={{backgroundColor:'red',borderRadius:'30px',height:'40px',padding:'3px'}} container alignItems={"center"} justify={"center"}>
                                <Grid sm={12} xs={12} style={{backgroundColor:'#000000',position:'relative',height:'100%',borderRadius:'30px',padding:'3px'}} container item alignItems={"center"} justify={"center"}>
                                    <p style={{position:'absolute',textAlign:'center'}}>
                                        رایگان
                                    </p>
                                </Grid>
                            </Grid>
                        }
                    </Grid>
                    <Grid  sm={4} xs={4} alignItems={"center"} direction={"row-reverse"}  justify={"center"} container style={{padding:'10px 0'}}>
                        <SquareAvatar data={avatarData}/>
                    </Grid>
                    { err &&
                        <Grid  sm={12} xs={12} alignItems={"center"}  direction={"row-reverse"} justify={"center"} container>
                            <p>
                                {err}
                            </p>
                        </Grid>
                    }
                    <Grid  sm={12} xs={12} alignItems={"center"}  direction={"row-reverse"} justify={"space-around"} container>
                        {
                            (dialog.ok && !err) &&
                            <Grid  sm={5} xs={5} alignItems={"center"} direction={"row-reverse"} justify={"center"}
                            onClick={()=>{
                            // this.props.action(okButton.action)
                            this.avatarBuy(id)
                        }} container>
                            {
                                !picoSmallLoader &&
                                <Grid className='clickable' style={{height: '50px'}} container alignItems={"center"} justify={"center"}>
                                    <IconButton data={okButton}/>
                                </Grid>
                            }
                            {
                                picoSmallLoader &&
                                <Grid sm={5} xs={5} container alignItems={"center"} direction={"row-reverse"} justify={"center"}
                                      style={{position:'relative',height:'50px'}}
                                >
                                    <Grid item container justify={"center"} alignItems={"center"} style={{position:'absolute'}}>
                                        <PicoLoader/>
                                    </Grid>
                                </Grid>
                            }
                            </Grid>
                        }
                        {
                            dialog.cancel &&
                            <Grid className='clickable' sm={5} xs={5} alignItems={"center"} direction={"row-reverse"}  justify={"center"} container style={{height:'50px'}}
                                  onClick={()=>{
                                      this.props.action(cancelButton.action)
                                  }}
                            >
                                <Button data={cancelButton}/>
                            </Grid>
                        }
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}
const mapStateToProps=state=>({
    UserData:state.UserData,
})
export default connect(mapStateToProps,{reduxData})(AvatarBuyDialog)
